export default __webpack_public_path__ + "static/media/walking_man_pers.1d009f48.svg";